// extracted by mini-css-extract-plugin
export default {"biobar-notifications-empty":"styles_biobar-notifications-empty__hff3J","icon":"styles_icon__RKuRU"};